/**
 * Las variables `{{n}}` de un cuerpo de plantilla, para el formulario de creación.
 *
 * ESTO NO ES LA VALIDACIÓN. La autoridad es el backend
 * (`functions/integrations/templates/plantillaDesdeFormulario.js`), que revalida todo
 * antes de llamar a Meta y responde con un código estable y un mensaje en claro. Aquí
 * sólo se decide CUÁNTOS campos de ejemplo pintar y cómo componer la vista previa,
 * que es una decisión de interfaz, no una regla de negocio.
 *
 * Se mantiene deliberadamente pequeño y sin exportar mensajes de error: duplicar aquí
 * las reglas del backend crearía dos fuentes de verdad que divergirían, y la que
 * manda es la que habla con Meta.
 */

/** Los índices `{{n}}`, en orden de aparición y sin repetir. */
export function variablesDelCuerpo(cuerpo) {
  if (typeof cuerpo !== 'string') return [];
  const vistos = [];
  for (const m of cuerpo.matchAll(/\{\{\s*(\d+)\s*\}\}/g)) {
    const n = Number(m[1]);
    if (!vistos.includes(n)) vistos.push(n);
  }
  return vistos;
}

/** Los mismos índices ordenados, que es el orden en el que Meta sustituye. */
export function variablesOrdenadas(cuerpo) {
  return [...variablesDelCuerpo(cuerpo)].sort((a, b) => a - b);
}

/**
 * `true` si la numeración es 1..n sin huecos. Sirve para avisar mientras el usuario
 * escribe; el rechazo formal lo emite el backend.
 */
export function numeracionCorrecta(cuerpo) {
  const ordenadas = variablesOrdenadas(cuerpo);
  return ordenadas.every((n, i) => n === i + 1);
}

/**
 * La vista previa: el cuerpo con cada `{{n}}` sustituido por su valor de ejemplo.
 *
 * El ejemplo ES la vista previa — no son dos cosas distintas. Una variable sin valor
 * todavía se deja como `{{n}}` para que se vea qué falta por rellenar.
 */
export function componerVistaPrevia(cuerpo, ejemplosPorIndice) {
  if (typeof cuerpo !== 'string') return '';
  return cuerpo.replace(/\{\{\s*(\d+)\s*\}\}/g, (original, n) => {
    const valor = ejemplosPorIndice?.[Number(n)];
    return (typeof valor === 'string' && valor.trim()) ? valor.trim() : original;
  });
}
